import http from "@/services/http";

const dashboard = (params = null) => { return http.get("dashboard-data", { params: params }) }

export default {
  dashboard
}
